module.exports = __webpack_public_path__ + "static/banner-update-data-pe-283caa05ee8f3dcfd37119e434e5030f.png";